<template>
  <div class="state-panel" :class="type">
    <LoaderCircle v-if="type === 'loading'" class="spin" :size="25" />
    <CircleAlert v-else-if="type === 'error'" :size="25" />
    <Inbox v-else :size="25" />
    <strong>{{ title }}</strong>
    <p v-if="message">{{ message }}</p>
    <button v-if="action" type="button" class="secondary-button" @click="$emit('action')">{{ action }}</button>
  </div>
</template>

<script setup>
import { CircleAlert, Inbox, LoaderCircle } from "lucide-vue-next";
defineProps({ type: { type: String, default: "empty" }, title: String, message: String, action: String });
defineEmits(["action"]);
</script>
